<template>
  <section class="begginers">
    <Banner
      :image-main="banner.img"
      :image-mobile="banner.imgMob"
      :title="banner.title"
    />
    <div class="begginers__wrapper">
      <OurOffers class="begginers__offers" :items="offers">
        {{ _T("@Key benefits of cooperation") }}
      </OurOffers>

      <InfoOffers
        class="begginers__info-offers"
        :img="infoOffers.img"
        :title="infoOffers.title"
        :subtitle="infoOffers.subtitle"
        :button="true"
      />

      <Suggestions
        class="begginers__suggestions"
        :img="suggestions.img"
        :title="suggestions.title"
        :subtitle="suggestions.subtitle"
        :direction-left="true"
      />

      <InfoOffers
        class="begginers__info-offers"
        :img="infoOffersGuard.img"
        :title="infoOffersGuard.title"
        :subtitle="infoOffersGuard.subtitle"
        :button="false"
      />

      <OurOffers
        class="begginers__offers"
        :items="offersCooperation"
        :submit="true"
        :short="true"
      >
        {{ _T("@How to start cooperation") }}
      </OurOffers>

      <FeedbackForm class="begginers__contacts" />
    </div>
  </section>
</template>

<script setup>
import Banner from "~/modules/shared/banner/Banner.vue";
import FeedbackForm from "~/modules/shared/feedbackForm/FeedbackForm.vue";
import InfoOffers from "~/modules/shared/offers/InfoOffers.vue";
import OurOffers from "~/modules/shared/offers/OurOffers.vue";
import Suggestions from "~/modules/shared/offers/Suggestions.vue";

useSeoMeta({
  title: _T("@Meta title wholesale"),
  description: _T("@Meta description wholesale"),
});

const banner = {
  img: "wholesale-img-ban.png",
  imgMob: "wholesale-img-ban-mob.png",
  title: "@Video surveillance wholesale",
};
const offers = [
  {
    title: "@Automatic unloading of goods of our brand",
    img: "price",
  },
  {
    title: "@Logistics We cooperate",
    img: "logistics",
  },
  {
    title: "@Information support",
    img: "helper",
  },
  {
    title: "@Free training for your employees",
    img: "training",
  },
];
const infoOffers = {
  title: "@How to become our partner",
  subtitle: "@Leave request on our wholesale portal",
  img: "b2b",
};
const offersCooperation = [
  {
    title: "@Leave request by filling out feedback form",
    img: "request",
  },
  {
    title: "@After that our manager will contact you",
    img: "manager",
  },
  {
    title: "@Complete training course in installation",
    img: "traning",
  },
];
const infoOffersGuard = {
  title: "@Warehouse residue protection",
  subtitle: "@Exclusive program",
  img: "residue-protection",
};
const suggestions = {
  img: "online-news",
  title: "@Greenvision is reliable importer",
  subtitle: "@Supports its partners",
};
</script>

<style lang="scss" scoped>
.begginers {
  background-color: var(--color-sky-lighter);

  &__wrapper {
    padding: 64px 0 136px 0;
  }

  &__promt,
  &__info-offers,
  &__suggestions {
    @extend %width-main;

    @extend %padding-wrp;
    margin: auto auto 64px auto;

    @include bigMobile {
      margin: auto auto 32px auto;
    }
  }

  &__offers {
    @extend %width-main;

    @extend %padding-wrp;
    margin: auto auto 32px auto;
  }

  &__contacts {
    @extend %width-main;

    @extend %padding-wrp;
    margin: auto;
  }
  &__call-back {
    @extend %width-main;

    @extend %padding-wrp;
    margin: auto;
  }
}
</style>
